<app-modal
  #discardChangesModal
  [modalMessage]="app.text.user.discard"
  (ok)="discardChanges()"
  >
</app-modal>
<app-modal
  #deleteUserModal
  [modalMessage]="app.text.user.deleteMessage"
  [modalTitle]="app.text.user.modalTitle"
  (ok)="app.users.delete()"
  >
</app-modal>
<div class="row mr-0">
  <div class="col-md-12">
    <div class="d-flex">
      <button class="btn btn-control me-auto p-2" (click)="toggleBar()">
        <i class="far fa-times"></i> &nbsp; {{ app.text.user.closeWindow }}
      </button>

      @if (app.unlockedId === null) {
        <span>
          @if (!app.users.isNew) {
            <span>
              <app-next
                class="pull-left"
                [current]="app.users.currentId"
                [array]="app.users.userIds"
                (navigate)="getNavigationUser($event)"
              ></app-next>
            </span>
          }
        </span>
      }
    </div>
  </div>
  <div class="row">
    <div class="m-1 mb-2 d-flex justify-content-end">
      <app-unlock
        [id]="app.users.currentId"
        [permission]="app.users.hasEditPermission() && !app.users.isNew"
        >
        @if (app.users.modelHasChanges()) {
          @if (!app.users.isNew) {
            <button
              class="btn btn-sm btn-clean"
              (click)="discardChangesModal.open()"
              >
              <i class="fas fa-times"></i>&nbsp;
              {{ app.text.user.discardBtn }}
            </button>
          }
        } @else {
          <button class="btn btn-sm btn-clean" (click)="discardChanges()">
            <i class="fas fa-times"></i>&nbsp;
            {{ app.text.user.closeBtn }}
          </button>
        }

      </app-unlock>

      @if (app.unlockedId === null) {
        <span>
          @if (!app.users.isNew) {
            <span>
              @if (
                app.model[this.app.fieldId.user.active] &&
                app.users.hasEditPermission()
                ) {
                <button
                  class="btn"
                  (click)="app.users.deactivateUser(); app.unlockedId = null"
                  [ngbTooltip]="app.text.user.deactivateUser"
                  >
                  <i class="fa fa-user-times"></i>
                </button>
              }
              @if (app.users.hasEditPermission()) {
                <button
                  class="btn btn-sm btn-delete"
                  (click)="deleteUserModal.open()"
                  [ngbTooltip]="app.text.user.delete"
                  >
                  <i class="fa fa-trash"></i>
                  {{ app.text.thread.delete }}
                </button>
              }
            </span>
          }
        </span>
      }
    </div>
    <!-- Current view is in view mode of a person -->
    @if (app.unlockedId === null) {
      <div class="col-md-12">
        <div class="legend m-4">{{ app.text.user.userInfo }}</div>
        <div class="m-2 p-2">
          <div class="col-md-12 form-group">
            <label class="font-size-12" for="name">{{
              app.field.getLabel(app.fieldId.user.firstName)
            }}</label>
            <div class="value">
              {{ app.users.currentUserModel["user.firstName"] }}
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label class="font-size-12" for="name">{{
              app.field.getLabel(app.fieldId.user.lastName)
            }}</label>
            <div class="value">
              {{ app.users.currentUserModel["user.lastName"] }}
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label class="font-size-12" for="email">{{
              app.field.getLabel(app.fieldId.user.email)
            }}</label>
            <div class="value">
              {{ app.users.currentUserModel["user.email"] }}
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label class="font-size-12" for="roles">{{
              app.field.getLabel(app.fieldId.user.roles)
            }}</label>
            <div class="value">
              @for (role of app.users.currentUserModel['user.roles']; track role) {
                <span>
                  {{
                  app.field.getOptionText(
                  "user.roles",
                  app.users.getCleanUserRole(role)
                  )
                  }}
                </span>
              }
            </div>
          </div>
          @if (app.list.user.columns.includes(app.fieldId.user.businessArea)) {
            <div class="col-md-12 form-group">
              <label class="font-size-12" for="businessArea">{{
                app.field.getLabel(app.fieldId.user.businessArea)
              }}</label>
              <div class="value">
                {{ app.users.currentUserModel["user.businessArea"] }}
              </div>
            </div>
          }
          <div class="col-md-3 form-group">
            <label class="font-size-12" for="active">{{
              app.field.getLabel(app.fieldId.user.active)
            }}</label>
            <div>
              @if (!app.users.currentUserModel['user.active']) {
                <i
                  class="fa fa-toggle-off check-off"
                  aria-hidden="true"
                ></i>
              }
              @if (app.users.currentUserModel['user.active']) {
                <i
                  class="fa fa-toggle-on check-on"
                  aria-hidden="true"
                ></i>
              }
            </div>
          </div>
        </div>
        <!-- Setting of multifactor authentication  -->
        @if (!app.auth.isTeam && app.profile.canEdit2FAForUser()) {
          <div
            class="col-md-12"
            >
            <div class="legend m-4">{{ app.text.userSettings.security }}</div>
            <div class="col-md-12">
              <div class="m-2">
                <div class="m-2 d-flex align-items-center">
                  <button class="btn" (click)="toggleMFAPreferences()">
                    @if (isMFAPreferenceEnabled()) {
                      <i
                        class="fa fa-toggle-on check-on"
                      ></i>
                    }
                    @if (!isMFAPreferenceEnabled()) {
                      <i
                        class="fa fa-toggle-off check-off"
                      ></i>
                    }
                  </button>
                  <label class="fieldNameC">{{
                    app.text.userSettings.MFAEmail
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        }
        <!-- Email preferences -->
        @if (app.userSettings.showEmailPreferencesBox()) {
          <div class="col-md-12">
            <div class="legend m-4">{{ app.text.user.emailPref }}</div>
            <div class="col-md-12">
              @if (app.unlockedId != null) {
                <div class="notify">
                  {{ app.text.user.emailNotif }}
                </div>
              }
              <app-user-settings></app-user-settings>
            </div>
          </div>
        }
        @if (app.unlockedId != null) {
          <div class="row centeredRow">
            <div class="col-md-6 text-center saveBtn" (click)="app.users.save()">
              <button class="saveBtn" [disabled]="app.users.isDisabled()">
                {{ app.text.user.edit }}
              </button>
            </div>
          </div>
        }
        <div class="col-md-12 creditsRow">
          <app-credits type="user" [isCreated]="true"></app-credits>
        </div>
        <div class="col-md-12 pr-0">
          <app-credits type="user" [isEdited]="true"></app-credits>
        </div>
      </div>
    }
    <!-- Current view is edit / creation mode  -->
    @if (app.users.currentUser !== null && app.unlockedId != null) {
      <div
        class="col-md-12 pr-0"
        >
        <div class="legend m-4">User Information</div>
        @for (box of app.list.user.boxes; track box) {
          <div class="m-4">
            @if (box != null) {
              <div>
                @for (field of getListOfFields(box); track field; let index = $index) {
                  <app-field
                    [model]="app.users.currentUserModel"
                    [field]="field"
                    [index]="index"
                    [disabled]="app.isLocked(app.users.currentId)"
                    [shadowInput]="true"
                    [noStriped]="true"
                  ></app-field>
                }
              </div>
            }
          </div>
        }
        <div
          class="row centeredRow"
          [ngClass]="{ disabled: app.users.isDisabled() }"
          >
          <div class="col-md-6 text-center saveBtn" (click)="app.users.save()">
            <button
              class="saveBtn"
              [disabled]="app.users.isDisabled() || app.users.btnClicked"
              >
              {{ app.text.user.edit }}
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
